import { colors } from 'pixel-base'
import styled from 'styled-components'

const FluidContainer = styled.div`
  width: 100%;
  padding: 7.5px 0px;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    219deg,
    rgb(142, 68, 173) 0%,
    rgb(179, 60, 255) 0%,
    rgb(243, 184, 251) 53%
  );
`

const OnBoardingContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  min-height: auto;
  height: auto;
  background: ${colors.white};
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  transition: height 1s ease 0s;
  /* transition: all 0.7s ease-in-out; */
`

const OnBoardingHeader = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  h2 {
    text-transform: uppercase;
    font-weight: 400;
    margin: 0;
    padding: 0;
  }
  h3 {
    font-weight: 400;
    text-transform: uppercase;
    margin: 0;
    padding: 0;
  }
`
const OnBoardingBody = styled.div``
const OnBoardingSteps = styled.div``
const OnBoardingStep = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  form {
    width: 100%;
    // max-width: 500px;
  }
  .Loki {
    width: 100%;
  }
`
const FormInputGroup = styled.div`
  width: 49%;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const SectionContainer = styled.div`
  /* padding: 20px; */
  /* height: calc(100vh - 275px); */
  overflow: auto;
  background: transparent;
  /* border-radius: 20px; */
  /* box-shadow: 0px 0px 3px #ccc; */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-content: center;

  width: 100%;

  &.start {
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
  }

  form {
    /* max-width: 60%; */
    &.full {
      max-width: 100%;
      height: 100%;
      overflow: auto;
    }
    label {
      font-weight: 500;
      text-transform: uppercase;
      margin-bottom: 5px;
    }
  }
`
const FormFlex = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: baseline;
  align-content: stretch;
  width: 100%;
  margin: 0 auto;
  /* padding: 15px; */
  gap: 5px;
  justify-content: space-evenly;
`
const FormElementContainer = styled.div<{ size?: string }>`
  width: ${(props) => props.size || '100%'};
  flex-basis: ${(props) => props.size || '100%'};
`
const UpdateButtons = styled.div<{ margin?: string; justify?: string }>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  justify-content: ${(props) => props.justify || 'flex-start'};
  align-items: center;
  align-content: center;
  gap: 5px;
  width: 100%;
  /* margin-left: 25px;
  margin-left: ${(props) => props.margin || '25px'}; */
  /* padding: 0px 15px; */
`

const OnboardingCard = styled.div`
  box-shadow: 0px 0px 3px ${colors.grayBorderLight};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: ${colors.white};
`

export {
  FluidContainer,
  OnBoardingContainer,
  OnBoardingHeader,
  OnBoardingBody,
  OnBoardingSteps,
  OnBoardingStep,
  FormInputGroup,
  SectionContainer,
  FormFlex,
  FormElementContainer,
  UpdateButtons,
  OnboardingCard,
}
